import { render, staticRenderFns } from "./selector.vue?vue&type=template&id=bd2d754c&"
import script from "./selector.vue?vue&type=script&lang=ts&"
export * from "./selector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports